export class contentModel {
    expired: number;
    token: string; 
    constructor() {
    }
}
 
export class UserStockModel {
    code: string;
    error: string;
    status: string;
    content: contentModel; 

    uid: string;
    ownerUid: string;
    token: string;  
    expired: number;
    
    constructor() {
    }
}
